import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="w-full bg-sage/10 px-5 py-12 sm:py-20" data-id="element-91" data-mp="1o5zqy212ub4m">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center rounded-2xl border border-sage/40 bg-white/60 p-8 text-center sm:p-12" data-id="element-92" data-mp="222wh019dfokg">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-sage/15 text-dark-green" data-id="element-93" data-mp="1j4k8mhqaaipx">
          <ShieldCheckIcon className="h-9 w-9" aria-hidden="true" data-id="element-94" data-mp="1ee3t8s2wkn0x" />
        </span>
        <h2 className="mt-5 font-serif-display text-2xl font-bold text-slate sm:text-3xl" data-id="element-95" data-mp="1ec0wlp78vvn8">
          Garantía de 7 días sin preguntas
        </h2>
        <p className="mt-2 text-sm font-medium text-dark-green sm:text-base" data-id="element-96" data-mp="lo52ms928hu5">
          Tu inversión está protegida
        </p>
        <div className="mt-6 space-y-4 text-sm leading-relaxed text-slate/75 sm:text-base" data-id="element-97" data-mp="oz9mozqlp9l1">
          <p data-id="element-98" data-mp="twrw0r8j5qtk">
            Accedé al sistema completo, revisá los 6 tomos y los 4 bonos, aplicalo en tus consultas y
            comprobá por vos misma si transforma tu práctica.
          </p>
          <p data-id="element-99" data-mp="12qep29lcsfz2">
            Si dentro de los primeros 7 días no es lo que esperabas, te devolvemos el 100% de tu
            inversión. Sin preguntas. Sin trámites complicados. Sin vueltas.
          </p>
          <p className="font-semibold italic text-slate" data-id="element-100" data-mp="b0a5ue9bxyzf">
            El riesgo es cero. La decisión es tuya.
          </p>
        </div>
        <div className="mt-8 w-full max-w-md" data-id="element-101" data-mp="k0f5g28a7t31">
          <CTAButton label="Obtener el acceso AHORA" data-id="element-102" data-mp="k1838dp9j891" />
          <p className="mt-3 text-xs text-slate/60 sm:text-sm" data-id="element-103" data-mp="1qgip66zc1xlb">Con garantía de 7 días incluida</p>
        </div>
      </motion.div>
    </section>;
}